import { WILDCARD_ALL, WORKSPACE_MESSAGES_SEND } from "../entityPermissions.js";

//#region src/services/IEntityPermissions.ts
/** Ident for the permissions sync event */
const RPC_EVENT_PERMISSIONS_SYNC_IDENT = "org.bloomstack.events.permissionsSync";
/** RPC emitter options for permissions_sync event */
const RPC_EVENT_PERMISSIONS_SYNC = {
	ident: RPC_EVENT_PERMISSIONS_SYNC_IDENT,
	description: "Event emitted when user permissions are synced (on auth or when permissions change)",
	params: [{
		name: "payload",
		type: "object",
		description: "The user's permissions across app, org, and workspace levels"
	}]
};
/**
* Stable IDs for built-in roles.
*/
const ROLE_ADMINS = "role_admins";
const ROLE_MEMBERS = "role_members";
const ROLE_WORKSPACE_PARTICIPANT = "role_workspace_participant";
/**
* Built-in roles for seeding.
*/
const ROLES = [
	{
		id: ROLE_ADMINS,
		name: "admins",
		scope: "app",
		permissions: [WILDCARD_ALL]
	},
	{
		id: ROLE_MEMBERS,
		name: "members",
		scope: "app",
		permissions: []
	},
	{
		id: ROLE_WORKSPACE_PARTICIPANT,
		name: "participant",
		scope: "workspace",
		permissions: [WORKSPACE_MESSAGES_SEND]
	}
];
const ENTITY_PERMISSIONS_SERVICE_IDENT = "org.bloomstack.services.EntityPermissions";
/**
* Create an EntityRef for an app.
*/
function appEntity(appId) {
	return {
		type: "app",
		id: appId
	};
}
/**
* Create an EntityRef for an organization.
*/
function orgEntity(orgId) {
	return {
		type: "org",
		id: orgId
	};
}
/**
* Create an EntityRef for a user.
*/
function userEntity(userId) {
	return {
		type: "user",
		id: userId
	};
}
/**
* Create an EntityRef for a workspace.
*/
function workspaceEntity(workspaceId, parentType, parentId) {
	return {
		type: "workspace",
		id: workspaceId,
		parent: {
			type: parentType,
			id: parentId
		}
	};
}

//#endregion
export { ENTITY_PERMISSIONS_SERVICE_IDENT, ROLES, ROLE_ADMINS, ROLE_MEMBERS, ROLE_WORKSPACE_PARTICIPANT, RPC_EVENT_PERMISSIONS_SYNC, RPC_EVENT_PERMISSIONS_SYNC_IDENT, appEntity, orgEntity, userEntity, workspaceEntity };
//# sourceMappingURL=IEntityPermissions.js.map